export interface RRIStorageService {
  setItem(
    key: string,
    value: any,
    toSessionStorage?: boolean,
    toGlobal?: boolean,
  ): void;
  getItem(
    key: string,
    parse?: boolean,
    toSessionStorage?: boolean,
    toGlobal?: boolean,
  ): any;
}
